const isBigNumber = num => !Number.isSafeInteger(+num)

const bigIntSubstrMatch = (matchingSubstr, prefix, num, decimal, suffix) => {
  if (isBigNumber(num)) {
    return `${prefix}"${num}${decimal || ''}"${suffix}`
  }
  return matchingSubstr
}

const enquoteBigNumber = jsonString => {
  // Match numbers, including optional decimal parts
  const matchRegex = /([:\s[,])(\d+)(\.\d+)?([\s,\]}])/g
  return jsonString.replaceAll(matchRegex, bigIntSubstrMatch)
}

export default enquoteBigNumber



// WEBPACK FOOTER //
// ./src/common/helpers/JSONBigIntTransfromer.js